module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"text":"By using the site you agree to the use of essential <strong>cookies</strong> to make signing in work. No other cookies are used."},"hu":{"text":"Az oldal használatával elfogadod, hogy a működéséhez szükséges <strong>sütiket</strong> mentünk el. Semmilyen más sütit nem használunk."}}')
  delete Component.options._Ctor
}
